"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";
import { AlertDialogWrapper } from "@components/common/containers/alert-dialog-wrapper";
import { Button } from "@components/ui/button";
import { Checkbox } from "@components/ui/checkbox";
import { Input } from "@components/ui/input";
import { Label } from "@components/ui/label";
import type { IssuedPersonalAccessToken } from "@features/personal-access-tokens/types";
interface PersonalAccessTokenSecretDialogProps {
  readonly isOpen: boolean;
  readonly issued: IssuedPersonalAccessToken;
  readonly ownerLabel?: string;
  readonly onClose: () => void;
}
export const PersonalAccessTokenSecretDialog = t0 => {
  const $ = _c(104);
  const {
    isOpen,
    issued,
    ownerLabel,
    onClose
  } = t0;
  const t = useTranslations("features.personal-access-tokens.ui.ownerTokensPage");
  const copyButtonRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);
  const [hasConfirmedSaving, setHasConfirmedSaving] = useState(false);
  const [isLeaveConfirmOpen, setIsLeaveConfirmOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      const preventAccidentalNavigation = _temp;
      window.addEventListener("beforeunload", preventAccidentalNavigation);
      return () => window.removeEventListener("beforeunload", preventAccidentalNavigation);
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== issued.secret) {
    t3 = async () => {
      setIsCopied(false);
      setCopyFailed(false);
      try {
        await navigator.clipboard.writeText(issued.secret);
        setIsCopied(true);
      } catch {
        setCopyFailed(true);
      }
    };
    $[3] = issued.secret;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const copySecret = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsLeaveConfirmOpen(true);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const requestLeave = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event_0 => {
      event_0.preventDefault();
      requestLeave();
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleEscapeKeyDown = t5;
  let t6;
  if ($[7] !== t) {
    t6 = t("secret.title");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("secret.description");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t("secret.savedAndClose");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !hasConfirmedSaving;
  let t10;
  if ($[13] !== onClose) {
    t10 = {
      onAction: async () => {
        onClose();
      }
    };
    $[13] = onClose;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("secret.back");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <Button type="button" variant="ghost" onClick={requestLeave}>{t11}</Button>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      content: "h-[100dvh] max-h-none rounded-none data-[vaul-drawer-direction=bottom]:mt-0 data-[vaul-drawer-direction=bottom]:max-h-none md:h-auto md:max-h-[95vh]"
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== issued.token.name) {
    t14 = <p className="text-sm font-medium">{issued.token.name}</p>;
    $[20] = issued.token.name;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== ownerLabel || $[23] !== t) {
    t15 = ownerLabel && <p className="text-sm text-muted-foreground">{t("secret.ownerLabel")}: {ownerLabel}</p>;
    $[22] = ownerLabel;
    $[23] = t;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t) {
    t16 = t("secret.secretLabel");
    $[25] = t;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <Label htmlFor="pat-issued-secret">{t16}</Label>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== issued.secret) {
    t18 = <Input id="pat-issued-secret" readOnly={true} value={issued.secret} autoComplete="off" spellCheck={false} className="font-mono" />;
    $[29] = issued.secret;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17 || $[32] !== t18) {
    t19 = <div className="grid gap-2">{t17}{t18}</div>;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== copySecret) {
    t20 = () => void copySecret();
    $[34] = copySecret;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t) {
    t21 = t("secret.copy");
    $[36] = t;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <Button ref={copyButtonRef} type="button" variant="outline" onClick={t20}>{t21}</Button>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== copyFailed || $[42] !== isCopied || $[43] !== t) {
    t23 = isCopied ? t("secret.copied") : copyFailed ? t("secret.copyFailed") : "";
    $[41] = copyFailed;
    $[42] = isCopied;
    $[43] = t;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t23) {
    t24 = <p role="status" aria-live="polite" className="min-h-5 text-sm text-muted-foreground">{t23}</p>;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t) {
    t25 = t("secret.warning");
    $[47] = t;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t25) {
    t26 = <p className="rounded-md border border-amber-500/50 bg-amber-50 p-3 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-100">{t25}</p>;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = checked => setHasConfirmedSaving(checked === true);
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== hasConfirmedSaving) {
    t28 = <Checkbox id="pat-secret-saved" checked={hasConfirmedSaving} onCheckedChange={t27} />;
    $[52] = hasConfirmedSaving;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t) {
    t29 = t("secret.savedConfirmation");
    $[54] = t;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t29) {
    t30 = <Label htmlFor="pat-secret-saved">{t29}</Label>;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== t28 || $[59] !== t30) {
    t31 = <div className="flex items-start gap-2">{t28}{t30}</div>;
    $[58] = t28;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t14 || $[62] !== t15 || $[63] !== t19 || $[64] !== t22 || $[65] !== t24 || $[66] !== t26 || $[67] !== t31) {
    t32 = <div className="space-y-4">{t14}{t15}{t19}{t22}{t24}{t26}{t31}</div>;
    $[61] = t14;
    $[62] = t15;
    $[63] = t19;
    $[64] = t22;
    $[65] = t24;
    $[66] = t26;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  let t33;
  if ($[69] !== isOpen || $[70] !== t10 || $[71] !== t12 || $[72] !== t32 || $[73] !== t6 || $[74] !== t7 || $[75] !== t8 || $[76] !== t9) {
    t33 = <AlertDialogWrapper isOpen={isOpen} title={t6} description={t7} closeDisabled={true} hideCloseButton={true} interceptEscapeWhenCloseDisabled={true} initialFocusRef={copyButtonRef} onEscapeKeyDown={handleEscapeKeyDown as never} actionTitle={t8} actionDisabled={t9} handlers={t10} footerNode={t12} classNames={t13}>{t32}</AlertDialogWrapper>;
    $[69] = isOpen;
    $[70] = t10;
    $[71] = t12;
    $[72] = t32;
    $[73] = t6;
    $[74] = t7;
    $[75] = t8;
    $[76] = t9;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t) {
    t34 = t("secret.leaveConfirm.title");
    $[78] = t;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t) {
    t35 = t("secret.leaveConfirm.description");
    $[80] = t;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t) {
    t36 = t("secret.leaveConfirm.cancel");
    $[82] = t;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t) {
    t37 = t("secret.leaveConfirm.confirm");
    $[84] = t;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== onClose) {
    t38 = {
      onAction: async () => {
        setIsLeaveConfirmOpen(false);
        onClose();
      }
    };
    $[86] = onClose;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = open => {
      if (!open) {
        setIsLeaveConfirmOpen(false);
      }
    };
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== t) {
    t40 = t("secret.leaveConfirm.note");
    $[89] = t;
    $[90] = t40;
  } else {
    t40 = $[90];
  }
  let t41;
  if ($[91] !== t40) {
    t41 = <p className="text-sm text-muted-foreground">{t40}</p>;
    $[91] = t40;
    $[92] = t41;
  } else {
    t41 = $[92];
  }
  let t42;
  if ($[93] !== isLeaveConfirmOpen || $[94] !== t34 || $[95] !== t35 || $[96] !== t36 || $[97] !== t37 || $[98] !== t38 || $[99] !== t41) {
    t42 = <AlertDialogWrapper isOpen={isLeaveConfirmOpen} title={t34} description={t35} closeTitle={t36} actionTitle={t37} handlers={t38} setIsOpenCallback={t39}>{t41}</AlertDialogWrapper>;
    $[93] = isLeaveConfirmOpen;
    $[94] = t34;
    $[95] = t35;
    $[96] = t36;
    $[97] = t37;
    $[98] = t38;
    $[99] = t41;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== t33 || $[102] !== t42) {
    t43 = <>{t33}{t42}</>;
    $[101] = t33;
    $[102] = t42;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  return t43;
};
function _temp(event) {
  event.preventDefault();
  event.returnValue = "";
}